import { render, staticRenderFns } from "./StandardTextCard.component.vue?vue&type=template&id=a08c94ec&scoped=true&"
import script from "./StandardTextCard.component.vue?vue&type=script&lang=js&"
export * from "./StandardTextCard.component.vue?vue&type=script&lang=js&"
import style0 from "./StandardTextCard.component.vue?vue&type=style&index=0&id=a08c94ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08c94ec",
  null
  
)

export default component.exports